import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const PARENT_IMYFORMS_OPEN_MODAL = 'PARENT_IMYFORMS_OPEN_MODAL';
export const PARENT_IMYFORMS_CLOSE_MODAL = 'PARENT_IMYFORMS_CLOSE_MODAL';
export const PARENT_IMYFORMS_REQUEST = 'PARENT_IMYFORMS_REQUEST';
export const PARENT_IMYFORMS_SUCCESS = 'PARENT_IMYFORMS_SUCCESS';
export const PARENT_IMYFORMS_FAILURE = 'PARENT_IMYFORMS_FAILURE';

function openParentImyFormsModal() {
  return {
    type: PARENT_IMYFORMS_OPEN_MODAL
  };
}

function closeParentImyFormsModalModal() {
  return {
    type: PARENT_IMYFORMS_CLOSE_MODAL
  };
}

function requestParentImyForms() {
  return {
    type: PARENT_IMYFORMS_REQUEST
  };
}

function receiveParentImyForms(parentImyForms) {
  return {
    type: PARENT_IMYFORMS_SUCCESS,
    parentImyForms
  };
}

function rejectParentImyForms() {
  return {
    type: PARENT_IMYFORMS_FAILURE
  };
}

export function getParentImyForms(customerId, accountId) {
  return (dispatch) => {
    dispatch(requestParentImyForms());

    const promise = () => ApiService
      .getParentImyForms(customerId, accountId)
      .then(response => dispatch(receiveParentImyForms(response.data)))
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectParentImyForms, true));
        }
      });
    return promise();
  };
}

export function showParentImyFormsModal(customerId, accountId) {
  return (dispatch) => {
    dispatch(getParentImyForms(customerId, accountId));
    return dispatch(openParentImyFormsModal());
  };
}

export function hideParentImyFormsModal() {
  return (dispatch) => {
    dispatch(closeParentImyFormsModalModal());
  };
}
